var image_upload_default = {
  "container": "siH3X",
  "disabled": "Oa-hm",
  "imageInput": "_8IbI7",
  "overlay": "NN3DL",
  "text": "_5zyoy",
  "shown": "-xQED",
  "hide": "F1sYu",
  "spinner": "idsYZ",
  "spin": "_9Q07Q"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
